var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "version"
  }, [!_vm.pageBoo ? _c('span', [_c('VersionNoPage'), _c('a', {
    on: {
      "click": _vm.onChangeAll
    }
  }, [_vm._v($t("7fm5sw8", "查看全部更新 >"))])], 1) : _c('VersionPage')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };